import React from 'react';
import styled from 'styled-components';

const BannerContainer = styled.div`
  background: linear-gradient(135deg, #7ECBB9 0%, #65A395 100%);
  color: white;
  padding: 2rem;
  border-radius: 16px;
  margin-bottom: 2rem;
  text-align: center;
  box-shadow: 0 4px 12px rgba(126, 203, 185, 0.2);
`;

const BannerTitle = styled.h2`
  font-family: 'Quicksand', sans-serif;
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: white;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const BannerText = styled.p`
  font-family: 'Nunito', sans-serif;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  opacity: 0.95;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const HighlightText = styled.span`
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
`;

const DonationText = styled.p`
  font-family: 'Nunito', sans-serif;
  font-size: 0.95rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  opacity: 0.9;
  
  a {
    color: white;
    text-decoration: underline;
    font-weight: 500;
    
    &:hover {
      text-decoration: none;
      opacity: 0.8;
    }
  }
`;

const FreeSignupBanner = () => {
  return (
    <BannerContainer>
      <BannerTitle>
        🎁 Limited Time: Free Sleep Plans for Australian Families
      </BannerTitle>
      
      <BannerText>
        We're offering <HighlightText>complimentary personalized sleep plans</HighlightText> to help 
        more parents and babies get the rest they deserve. Create your account below and receive 
        your AI-powered sleep plan at no cost.
      </BannerText>
      
      <BannerText>
        <HighlightText>No payment required</HighlightText> • <HighlightText>No credit card needed</HighlightText> • <HighlightText>Instant access</HighlightText>
      </BannerText>
      
      <DonationText>
        If our sleep plan helps your family, consider making a donation to{' '}
        <a 
          href="https://www.cancercouncil.com.au/get-involved/donate/" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Cancer Council Australia
        </a>{' '}
        to support families facing cancer challenges.
      </DonationText>
    </BannerContainer>
  );
};

export default FreeSignupBanner;
